import React, { useContext, useEffect, useState } from "react"
import Context from "../utils/Context"
import { cancelActions, sendJourney, sendTaskToRobot } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStopCircle } from "@fortawesome/free-solid-svg-icons"
import api from "../api/api"

export default function ModalVerification() {
    const context = useContext(Context)

    const [maxWeight, setMaxWeight] = useState(0)
    const [maxHeight, setMaxHeight] = useState(0)

    useEffect(() => {
        api.fetchRacks()
            .then((res) => {
                const racks = res.data

                setMaxHeight(parseFloat(racks?.find(r => r.pointName === context.lastDrop.point && r.forkHeight === context.lastDrop.height)?.maxHeight) - 0.25)
                setMaxWeight(racks?.find(r => r.pointName === context.lastDrop.point && r.forkHeight === context.lastDrop.height)?.maxWeight)
            })
    }, [])

    useEffect(() => {
        if (context.endOfMission) context.actions.setModalState({ ...context.modalState, verification: false })
    }, [context.endOfMission])

    const cancelAll = () => {
        cancelActions({ stopAll: true }, context.selectedRobot.ROS)
        context.actions.setCurrentMission(null)

        if (context.currentTask === 'weigh') {
            var weighRetreat = {
                "name": "Weigh Retreat",
                "actions": [
                    {
                        "id": "fork",
                        "name": "fork",
                        "needsValue": true,
                        "value": (context.forkHeight - 0.15).toString()
                    },
                    {
                        "id": "undock-pallet",
                        "name": "undock-pallet",
                        "needsValue": false
                    },
                    {
                        "id": "fork",
                        "name": "fork",
                        "needsValue": true,
                        "value": "0.0"
                    },
                ]
            }

            console.log('publicando missão: ', { actions: weighRetreat.actions, id: weighRetreat.name, name: weighRetreat.name })
            sendTaskToRobot({ actions: weighRetreat.actions, name: weighRetreat.name, id: weighRetreat.name })
        }
        context.actions.setModalState({ ...context.modalState, verification: false })
    }

    return (
        <div className="modal is-active">
            <div className="modal-background"></div>

            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <header className="modal-card-head">
                    <p className="modal-card-title">{context.currentTask === 'weigh' ? 'Weight ' : 'Height '}Check</p>
                </header>

                <section className="modal-card-body">
                    <div className="field mb-5">
                        <div className="controls">
                            <div className="control mb-3">
                                <p>
                                    The destination rack has a {context.currentTask === 'weigh' ? ('weight limit of ' + maxWeight + 'kg ') : ('height limit of ' + maxHeight + 'm ')}and the pallet does not meet those standards.
                                </p>
                            </div>

                            <div className="control mb-3">
                                <p>
                                    You will have to cancel everything in order to send new missions.
                                    {context.currentTask === 'weigh' ? ' The robot must also put this pallet down and retreat before returning to the operation.' : ''}
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <footer className="modal-card-foot">
                    <button className="button is-danger" onClick={cancelAll}>
                        <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
                        Cancel All
                    </button>
                </footer>
            </div>
        </div>
    )
}